const products = [
  {
    id: 'vpn',
    name: 'VPN Application',
    tagline: 'Secure. Private. Unrestricted.',
    description:
      'Our VPN application delivers military-grade encryption and a global server network to keep your data safe and your browsing private. Designed for iOS with a zero-log policy, it ensures your digital footprint stays yours alone.',
    features: [
      { icon: 'ri-lock-2-line', text: 'Military-grade AES-256 encryption' },
      { icon: 'ri-global-line', text: 'Global server network across 50+ countries' },
      { icon: 'ri-eye-off-line', text: 'Strict zero-log privacy policy' },
      { icon: 'ri-flashlight-line', text: 'Lightning-fast connection speeds' },
      { icon: 'ri-wifi-line', text: 'Automatic kill switch protection' },
    ],
    gradient: 'from-indigo-600 via-violet-600 to-purple-700',
    accentColor: 'text-violet-300',
    badgeBg: 'bg-violet-500/20',
    image: 'https://public.readdy.ai/ai/img_res/cce3b0424eddef7f39c266fe8da22fc6.jpg',
  },
  {
    id: 'cleaner',
    name: 'Cleaner Application',
    tagline: 'Optimize. Clean. Perform.',
    description:
      'The Cleaner app intelligently scans your iPhone for junk files, duplicate photos, and unnecessary caches — freeing up storage and boosting performance with a single tap. Keep your device running like new, every day.',
    features: [
      { icon: 'ri-delete-bin-line', text: 'Smart junk file detection & removal' },
      { icon: 'ri-image-2-line', text: 'Duplicate photo & video cleanup' },
      { icon: 'ri-battery-charge-line', text: 'Battery life optimization tips' },
      { icon: 'ri-speed-line', text: 'One-tap system performance boost' },
      { icon: 'ri-hard-drive-2-line', text: 'Deep storage analysis & insights' },
    ],
    gradient: 'from-emerald-500 via-teal-500 to-cyan-600',
    accentColor: 'text-emerald-300',
    badgeBg: 'bg-emerald-500/20',
    image: 'https://readdy.ai/api/search-image?query=modern%20iOS%20cleaner%20app%20interface%20on%20iPhone%20showing%20storage%20optimization%20dashboard%20with%20circular%20progress%20indicators%20and%20clean%20statistics%2C%20fresh%20green%20and%20teal%20gradient%20background%2C%20minimalist%20mobile%20UI%20design%2C%20device%20optimization%20app%20concept%2C%20professional%20product%20mockup%20on%20simple%20light%20background&width=480&height=560&seq=vitek-cleaner-product&orientation=portrait',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-1.5 mb-5">
            <span className="text-slate-500 text-xs font-semibold tracking-widest uppercase">Our Products</span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-slate-900 mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Powerful iOS Applications
          </h2>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            Designed to enhance security and optimize performance — built exclusively for the iOS platform.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className={`relative rounded-3xl overflow-hidden bg-gradient-to-br ${product.gradient} p-8 md:p-10 flex flex-col gap-6`}
            >
              {/* Decorative glow */}
              <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white/5 blur-3xl pointer-events-none"></div>

              {/* Top row */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
                <div className="flex-1">
                  <div className={`inline-flex items-center gap-2 ${product.badgeBg} rounded-full px-3 py-1 mb-3`}>
                    <span className={`text-xs font-semibold ${product.accentColor} tracking-wide`}>iOS App</span>
                  </div>
                  <h3
                    className="text-2xl md:text-3xl font-bold text-white mb-2"
                    style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  >
                    {product.name}
                  </h3>
                  <p className={`text-sm font-medium ${product.accentColor}`}>{product.tagline}</p>
                </div>
                <div className="w-32 h-40 sm:w-36 sm:h-44 rounded-2xl overflow-hidden shrink-0">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Description */}
              <p className="text-white/80 text-sm md:text-base leading-relaxed">
                {product.description}
              </p>

              {/* Features list */}
              <ul className="space-y-2.5">
                {product.features.map((f) => (
                  <li key={f.text} className="flex items-center gap-3">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/15 shrink-0">
                      <i className={`${f.icon} text-white text-sm`}></i>
                    </div>
                    <span className="text-white/90 text-sm">{f.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
